import { useState } from 'react'
import { Body, Box, Bullets, H4,  } from '../widgets'
import { PriceCard, PriceSelect, SubscriptionFeatures } from './'
import { subscriptionTypes, partner } from '../../lookups'
import './PartnerPricing.scss'
import { useBreakpoints } from '@10000/react'

export const PartnerPricing = ({ onSubscriptionSelected, small, dark }) => {
  const [teamsSelected, setTeamsSelected] = useState(0)
  const { mobile } = useBreakpoints()

  const teamOptionSelected = (value) => {
    setTeamsSelected(value)
    onSubscriptionSelected(partner[value].id)
  }

  return <Box>
    {!small && <Box className="desktop-only" gap={mobile ? 16 : 32} fullWidth p="8px 32px">
      <PriceCard
        type="partner"
        name={subscriptionTypes['partner'].title}
        description={subscriptionTypes['partner'].description}
        selected
        onSubscriptionSelected={onSubscriptionSelected}
      />

      <Box className="partner-subscription-description" column gap={16}>
        <H4 align="left">Pricing</H4>

        <PriceSelect onTeamOptionSelected={teamOptionSelected} pricing={partner} value={teamsSelected} dark={dark} />

        <Box column fullWidth gap={16}>
          <Bullets items={[
            <Box key={0} column gap={4}>
              <Body bold>Manage clients</Body>
              <Body>Simplify client management with our easy-to-navigate dashboard. Instantly access and manage all client data and performance, ensuring a seamless experience for you and clients.</Body>
            </Box>,
            <Box key={1} column gap={4}>
              <Body bold>Access to the Pod&Hive partner facilitator network</Body>
              <Body>Join Hive and access a dynamic resource hub for facilitators. Benefit from ongoing expert guidance, learn practical tips and tricks, and collaborate with a vibrant international network to enhance your skills.</Body>
            </Box>,
            <Box key={2} column gap={4}>
              <Body bold>Continuous help and support</Body>
              <Body>As your partner, we are invested in your  success. Our trained Customer Support specialists are readily available to provide expert assistance whenever you need it.</Body>
            </Box>,
          ]} />
        </Box>
      </Box>
    </Box>}

    <Box className={!small ? "mobile-only" : ''} column gap={16}>
      <PriceSelect onTeamOptionSelected={teamOptionSelected} pricing={partner} value={teamsSelected} dark={dark} />
      <SubscriptionFeatures subscriptionType='partner' dark={dark} />
    </Box>
  </Box>
}